import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useState } from "react";
import { useData } from "@/context/DataContext";
import { CreateChannelBox } from "@/components/CreateChannelBox";

const TYPE_ICON = { text: "#", announcement: "📢", voice: "🔊", stage: "🎙️", forum: "🗂️", category: "📁" };

export function ChannelSelect({ value, onChange, types = ["text", "announcement"], placeholder = "Seleziona un canale", testId, suggestName = "", privateDefault }) {
  const { channels } = useData();
  const [creating, setCreating] = useState(false);
  const list = channels.filter((c) => types.includes(c.type));
  const onlyCategory = types.length === 1 && types[0] === "category";
  const canCreate = onlyCategory || types.includes("text");
  return (
    <div className="space-y-2">
      <Select value={value || ""} onValueChange={(v) => (v === "__create__" ? setCreating(true) : onChange(v))}>
        <SelectTrigger data-testid={testId} className="bg-[#131620] border-[#232838] text-[#DBDEE1]">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-[#161923] border-[#232838] text-[#DBDEE1] max-h-72">
          {canCreate && (
            <SelectItem value="__create__" className="border-b border-[#232838] focus:bg-[#5865F2]/20">
              <span className="font-semibold text-[#8ea0ff]">{onlyCategory ? "➕ Crea una nuova categoria…" : "➕ Crea un nuovo canale…"}</span>
            </SelectItem>
          )}
          {list.length === 0 && <div className="px-3 py-2 text-xs text-[#949BA4]">Nessun canale</div>}
          {list.map((c) => (
            <SelectItem key={c.id} value={c.id} className="focus:bg-[#252B3D]">
              <span className="mr-1 text-[#949BA4]">{TYPE_ICON[c.type] || "#"}</span>{c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {creating && (
        <CreateChannelBox isCategory={onlyCategory} suggestName={suggestName} privateDefault={privateDefault}
          onCancel={() => setCreating(false)} onCreated={(id) => { setCreating(false); onChange(id); }} />
      )}
    </div>
  );
}

export function RoleSelect({ value, onChange, placeholder = "Seleziona un ruolo", testId, includeEveryone = false }) {
  const { roles } = useData();
  const list = roles.filter((r) => includeEveryone || !r.isEveryone);
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="bg-[#131620] border-[#232838] text-[#DBDEE1]">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-[#161923] border-[#232838] text-[#DBDEE1] max-h-72">
        {list.map((r) => (
          <SelectItem key={r.id} value={r.id} className="focus:bg-[#252B3D]">
            <span className="mr-2 inline-block h-2.5 w-2.5 rounded-full align-middle" style={{ background: r.color || "#99AAB5" }} />
            {r.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function MultiCheck({ options, value = [], onChange, testId }) {
  const toggle = (v) => {
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };
  return (
    <div data-testid={testId} className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
      {options.map((o) => {
        const val = o.value ?? o;
        const label = o.label ?? o.name ?? o;
        const checked = value.includes(val);
        return (
          <button
            key={val}
            type="button"
            onClick={() => toggle(val)}
            className={`flex items-center gap-2 rounded-md border px-3 py-2 text-left text-sm transition-colors ${
              checked ? "border-[#5865F2] bg-[#5865F2]/15 text-white" : "border-[#232838] bg-[#131620] text-[#B5BAC1] hover:bg-[#252B3D]"
            }`}
          >
            <span className={`flex h-4 w-4 items-center justify-center rounded border ${checked ? "border-[#5865F2] bg-[#5865F2]" : "border-[#4b4d54]"}`}>
              {checked && <span className="text-[10px] text-white">✓</span>}
            </span>
            <span className="truncate">{o.color && <span className="mr-1 inline-block h-2 w-2 rounded-full" style={{ background: o.color }} />}{label}</span>
          </button>
        );
      })}
    </div>
  );
}
